// extracted by mini-css-extract-plugin
export default {"productShopWrapper":"styles_productShopWrapper__rIz6o"};